/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getDevice = /* GraphQL */ `
  query GetDevice($id: ID!) {
    getDevice(id: $id) {
      id
      deviceID
      image
      name
      location
      Room {
        id
        name
        description
        address
        wifiName
        wifiPass
        pmsID
        superhogEnabled
        superhogChannels
        mountLinks
        viatorLink
        viatorID
        color
        checkInSchedule
        ciboLink
        images
        checkIn {
          description
          image
        }
        checkOut {
          description
          image
        }
        guides {
          nextToken
          startedAt
        }
        checkInTime
        checkOutTime
        Bookings {
          nextToken
          startedAt
        }
        Device {
          id
          deviceID
          image
          name
          location
          createdAt
          updatedAt
          deviceRoomId
          owner
        }
        upsells {
          nextToken
          startedAt
        }
        catalogs {
          nextToken
        }
        securityItems {
          nextToken
        }
        createdAt
        updatedAt
        roomDeviceId
        owner
      }
      createdAt
      updatedAt
      deviceRoomId
      owner
    }
  }
`;
export const listDevices = /* GraphQL */ `
  query ListDevices(
    $filter: ModelDeviceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDevices(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        deviceID
        image
        name
        location
        Room {
          id
          name
          description
          address
          wifiName
          wifiPass
          pmsID
          superhogEnabled
          superhogChannels
          mountLinks
          viatorLink
          viatorID
          color
          checkInSchedule
          ciboLink
          images
          checkInTime
          checkOutTime
          createdAt
          updatedAt
          roomDeviceId
          owner
        }
        createdAt
        updatedAt
        deviceRoomId
        owner
      }
      nextToken
      startedAt
    }
  }
`;
export const getServiceCategory = /* GraphQL */ `
  query GetServiceCategory($id: ID!) {
    getServiceCategory(id: $id) {
      id
      name
      description
      isActive
      products {
        items {
          id
          name
          price
          description
          perDay
          availible
          images
          isActive
          serviceCategoryID
          createdAt
          updatedAt
          owner
        }
        nextToken
        startedAt
      }
      rooms {
        items {
          id
          roomID
          categoryID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listServiceCategories = /* GraphQL */ `
  query ListServiceCategories(
    $filter: ModelServiceCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listServiceCategories(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        isActive
        products {
          nextToken
          startedAt
        }
        rooms {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      nextToken
      startedAt
    }
  }
`;
export const getServiceProduct = /* GraphQL */ `
  query GetServiceProduct($id: ID!) {
    getServiceProduct(id: $id) {
      id
      name
      price
      description
      perDay
      availible
      images
      isActive
      serviceCategoryID
      serviceCategory {
        id
        name
        description
        isActive
        products {
          nextToken
          startedAt
        }
        rooms {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      bookings {
        items {
          id
          startTime
          endTime
          lengthDays
          bookingID
          productID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listServiceProducts = /* GraphQL */ `
  query ListServiceProducts(
    $filter: ModelServiceProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listServiceProducts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        price
        description
        perDay
        availible
        images
        isActive
        serviceCategoryID
        serviceCategory {
          id
          name
          description
          isActive
          createdAt
          updatedAt
          owner
        }
        bookings {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      nextToken
      startedAt
    }
  }
`;
export const getBookingItem = /* GraphQL */ `
  query GetBookingItem($id: ID!) {
    getBookingItem(id: $id) {
      id
      startTime
      endTime
      lengthDays
      bookingID
      productID
      booking {
        id
        notes
        checkInDate
        status
        pmsBookingID
        reservationID
        superhogStatus
        checkOutDate
        guestID
        deviceID
        codeID
        upsells {
          nextToken
          startedAt
        }
        products {
          nextToken
        }
        triggerNotification
        message
        dateSchedule
        source
        code
        roomID
        securityItems {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      product {
        id
        name
        price
        description
        perDay
        availible
        images
        isActive
        serviceCategoryID
        serviceCategory {
          id
          name
          description
          isActive
          createdAt
          updatedAt
          owner
        }
        bookings {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listBookingItems = /* GraphQL */ `
  query ListBookingItems(
    $filter: ModelBookingItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBookingItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        startTime
        endTime
        lengthDays
        bookingID
        productID
        booking {
          id
          notes
          checkInDate
          status
          pmsBookingID
          reservationID
          superhogStatus
          checkOutDate
          guestID
          deviceID
          codeID
          triggerNotification
          message
          dateSchedule
          source
          code
          roomID
          createdAt
          updatedAt
          owner
        }
        product {
          id
          name
          price
          description
          perDay
          availible
          images
          isActive
          serviceCategoryID
          createdAt
          updatedAt
          owner
        }
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getRoomCatalog = /* GraphQL */ `
  query GetRoomCatalog($id: ID!) {
    getRoomCatalog(id: $id) {
      id
      roomID
      categoryID
      room {
        id
        name
        description
        address
        wifiName
        wifiPass
        pmsID
        superhogEnabled
        superhogChannels
        mountLinks
        viatorLink
        viatorID
        color
        checkInSchedule
        ciboLink
        images
        checkIn {
          description
          image
        }
        checkOut {
          description
          image
        }
        guides {
          nextToken
          startedAt
        }
        checkInTime
        checkOutTime
        Bookings {
          nextToken
          startedAt
        }
        Device {
          id
          deviceID
          image
          name
          location
          createdAt
          updatedAt
          deviceRoomId
          owner
        }
        upsells {
          nextToken
          startedAt
        }
        catalogs {
          nextToken
        }
        securityItems {
          nextToken
        }
        createdAt
        updatedAt
        roomDeviceId
        owner
      }
      category {
        id
        name
        description
        isActive
        products {
          nextToken
          startedAt
        }
        rooms {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listRoomCatalogs = /* GraphQL */ `
  query ListRoomCatalogs(
    $filter: ModelRoomCatalogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRoomCatalogs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        roomID
        categoryID
        room {
          id
          name
          description
          address
          wifiName
          wifiPass
          pmsID
          superhogEnabled
          superhogChannels
          mountLinks
          viatorLink
          viatorID
          color
          checkInSchedule
          ciboLink
          images
          checkInTime
          checkOutTime
          createdAt
          updatedAt
          roomDeviceId
          owner
        }
        category {
          id
          name
          description
          isActive
          createdAt
          updatedAt
          owner
        }
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getSecurityItem = /* GraphQL */ `
  query GetSecurityItem($id: ID!) {
    getSecurityItem(id: $id) {
      id
      type
      isActive
      channels
      documents
      hasDeposit
      amount
      perStayEnabled
      perStayAmount
      truviEnabled
      bookings {
        items {
          id
          status
          type
          signatures
          bookingID
          securityItemID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      rooms {
        items {
          id
          roomID
          securityItemID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listSecurityItems = /* GraphQL */ `
  query ListSecurityItems(
    $filter: ModelSecurityItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSecurityItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        type
        isActive
        channels
        documents
        amount
        bookings {
          nextToken
        }
        rooms {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getRoomSecurityItem = /* GraphQL */ `
  query GetRoomSecurityItem($id: ID!) {
    getRoomSecurityItem(id: $id) {
      id
      roomID
      securityItemID
      room {
        id
        name
        description
        address
        wifiName
        wifiPass
        pmsID
        superhogEnabled
        superhogChannels
        mountLinks
        viatorLink
        viatorID
        color
        checkInSchedule
        ciboLink
        images
        checkIn {
          description
          image
        }
        checkOut {
          description
          image
        }
        guides {
          nextToken
          startedAt
        }
        checkInTime
        checkOutTime
        Bookings {
          nextToken
          startedAt
        }
        Device {
          id
          deviceID
          image
          name
          location
          createdAt
          updatedAt
          deviceRoomId
          owner
        }
        upsells {
          nextToken
          startedAt
        }
        catalogs {
          nextToken
        }
        securityItems {
          nextToken
        }
        createdAt
        updatedAt
        roomDeviceId
        owner
      }
      securityItem {
        id
        type
        isActive
        channels
        documents
        amount
        bookings {
          nextToken
        }
        rooms {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listRoomSecurityItems = /* GraphQL */ `
  query ListRoomSecurityItems(
    $filter: ModelRoomSecurityItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRoomSecurityItems(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        roomID
        securityItemID
        room {
          id
          name
          description
          address
          wifiName
          wifiPass
          pmsID
          superhogEnabled
          superhogChannels
          mountLinks
          viatorLink
          viatorID
          color
          checkInSchedule
          ciboLink
          images
          checkInTime
          checkOutTime
          createdAt
          updatedAt
          roomDeviceId
          owner
        }
        securityItem {
          id
          type
          isActive
          channels
          documents
          amount
          createdAt
          updatedAt
          owner
        }
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getBookingSecurityItem = /* GraphQL */ `
  query GetBookingSecurityItem($id: ID!) {
    getBookingSecurityItem(id: $id) {
      id
      status
      type
      signatures
      bookingID
      securityItemID
      booking {
        id
        notes
        checkInDate
        status
        pmsBookingID
        reservationID
        superhogStatus
        checkOutDate
        guestID
        deviceID
        codeID
        upsells {
          nextToken
          startedAt
        }
        products {
          nextToken
        }
        triggerNotification
        message
        dateSchedule
        source
        code
        roomID
        securityItems {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      securityItem {
        id
        type
        isActive
        channels
        documents
        amount
        bookings {
          nextToken
        }
        rooms {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listBookingSecurityItems = /* GraphQL */ `
  query ListBookingSecurityItems(
    $filter: ModelBookingSecurityItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBookingSecurityItems(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        type
        signatures
        bookingID
        securityItemID
        booking {
          id
          notes
          checkInDate
          status
          pmsBookingID
          reservationID
          superhogStatus
          checkOutDate
          guestID
          deviceID
          codeID
          triggerNotification
          message
          dateSchedule
          source
          code
          roomID
          createdAt
          updatedAt
          owner
        }
        securityItem {
          id
          type
          isActive
          channels
          documents
          amount
          createdAt
          updatedAt
          owner
        }
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getContactGroup = /* GraphQL */ `
  query GetContactGroup($id: ID!) {
    getContactGroup(id: $id) {
      id
      name
      contacts
      upsells {
        items {
          id
          contactGroupID
          upsellID
          relationshipType
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listContactGroups = /* GraphQL */ `
  query ListContactGroups(
    $filter: ModelContactGroupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listContactGroups(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        contacts
        upsells {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getUpsellContactGroup = /* GraphQL */ `
  query GetUpsellContactGroup($id: ID!) {
    getUpsellContactGroup(id: $id) {
      id
      contactGroupID
      upsellID
      contactGroup {
        id
        name
        contacts
        upsells {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      upsell {
        id
        name
        type
        price
        images
        description
        saleType
        isActive
        prodID
        bookings {
          nextToken
          startedAt
        }
        rooms {
          nextToken
          startedAt
        }
        contactGroups {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      relationshipType
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listUpsellContactGroups = /* GraphQL */ `
  query ListUpsellContactGroups(
    $filter: ModelUpsellContactGroupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUpsellContactGroups(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        contactGroupID
        upsellID
        contactGroup {
          id
          name
          contacts
          createdAt
          updatedAt
          owner
        }
        upsell {
          id
          name
          type
          price
          images
          description
          saleType
          isActive
          prodID
          createdAt
          updatedAt
          owner
        }
        relationshipType
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getUpsell = /* GraphQL */ `
  query GetUpsell($id: ID!) {
    getUpsell(id: $id) {
      id
      name
      type
      price
      images
      description
      saleType
      isActive
      prodID
      bookings {
        items {
          id
          status
          payIntent
          payMethod
          bookingID
          upsellID
          createdAt
          updatedAt
          owner
        }
        nextToken
        startedAt
      }
      rooms {
        items {
          id
          roomID
          upsellID
          createdAt
          updatedAt
          owner
        }
        nextToken
        startedAt
      }
      contactGroups {
        items {
          id
          contactGroupID
          upsellID
          relationshipType
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listUpsells = /* GraphQL */ `
  query ListUpsells(
    $filter: ModelUpsellFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUpsells(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        type
        price
        images
        description
        saleType
        isActive
        prodID
        bookings {
          nextToken
          startedAt
        }
        rooms {
          nextToken
          startedAt
        }
        contactGroups {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      nextToken
      startedAt
    }
  }
`;
export const getBooking = /* GraphQL */ `
  query GetBooking($id: ID!) {
    getBooking(id: $id) {
      id
      notes
      checkInDate
      status
      pmsBookingID
      reservationID
      superhogStatus
      checkOutDate
      guestID
      deviceID
      codeID
      upsells {
        items {
          id
          status
          payIntent
          payMethod
          bookingID
          upsellID
          createdAt
          updatedAt
          owner
        }
        nextToken
        startedAt
      }
      products {
        items {
          id
          startTime
          endTime
          lengthDays
          bookingID
          productID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      triggerNotification
      message
      dateSchedule
      source
      code
      roomID
      securityItems {
        items {
          id
          status
          isComplete
          isCompleteSignatures
          hasDeposit
          verificationId
          type
          signatures
          bookingID
          securityItemID
          metas
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listBookings = /* GraphQL */ `
  query ListBookings(
    $filter: ModelBookingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBookings(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        notes
        checkInDate
        status
        pmsBookingID
        reservationID
        superhogStatus
        checkOutDate
        guestID
        deviceID
        codeID
        upsells {
          nextToken
          startedAt
        }
        products {
          nextToken
        }
        triggerNotification
        message
        dateSchedule
        source
        code
        roomID
        securityItems {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      nextToken
      startedAt
    }
  }
`;
export const getBookingUpsell = /* GraphQL */ `
  query GetBookingUpsell($id: ID!) {
    getBookingUpsell(id: $id) {
      id
      status
      payIntent
      payMethod
      bookingID
      upsellID
      booking {
        id
        notes
        checkInDate
        status
        pmsBookingID
        reservationID
        superhogStatus
        checkOutDate
        guestID
        deviceID
        codeID
        upsells {
          nextToken
          startedAt
        }
        products {
          nextToken
        }
        triggerNotification
        message
        dateSchedule
        source
        code
        roomID
        securityItems {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      upsell {
        id
        name
        type
        price
        images
        description
        saleType
        isActive
        prodID
        bookings {
          nextToken
          startedAt
        }
        rooms {
          nextToken
          startedAt
        }
        contactGroups {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listBookingUpsells = /* GraphQL */ `
  query ListBookingUpsells(
    $filter: ModelBookingUpsellFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBookingUpsells(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        status
        payIntent
        payMethod
        bookingID
        upsellID
        booking {
          id
          notes
          checkInDate
          status
          pmsBookingID
          reservationID
          superhogStatus
          checkOutDate
          guestID
          deviceID
          codeID
          triggerNotification
          message
          dateSchedule
          source
          code
          roomID
          createdAt
          updatedAt
          owner
        }
        upsell {
          id
          name
          type
          price
          images
          description
          saleType
          isActive
          prodID
          createdAt
          updatedAt
          owner
        }
        createdAt
        updatedAt
        owner
      }
      nextToken
      startedAt
    }
  }
`;
export const getGuest = /* GraphQL */ `
  query GetGuest($id: ID!) {
    getGuest(id: $id) {
      id
      name
      notes
      phone
      email
      Bookings {
        items {
          id
          notes
          checkInDate
          status
          pmsBookingID
          reservationID
          superhogStatus
          checkOutDate
          guestID
          deviceID
          codeID
          triggerNotification
          message
          dateSchedule
          source
          code
          roomID
          createdAt
          updatedAt
          owner
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listGuests = /* GraphQL */ `
  query ListGuests(
    $filter: ModelGuestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGuests(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        notes
        phone
        email
        Bookings {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        owner
      }
      nextToken
      startedAt
    }
  }
`;
export const getGuideCatalog = /* GraphQL */ `
  query GetGuideCatalog($id: ID!) {
    getGuideCatalog(id: $id) {
      id
      name
      isActive
      guides {
        items {
          id
          title
          description
          images
          guideCatalogID
          createdAt
          updatedAt
          owner
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listGuideCatalogs = /* GraphQL */ `
  query ListGuideCatalogs(
    $filter: ModelGuideCatalogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGuideCatalogs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        isActive
        guides {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getGuide = /* GraphQL */ `
  query GetGuide($id: ID!) {
    getGuide(id: $id) {
      id
      title
      description
      images
      rooms {
        items {
          id
          guideId
          roomId
          createdAt
          updatedAt
          owner
        }
        nextToken
        startedAt
      }
      guideCatalogID
      guideCatalog {
        id
        name
        isActive
        guides {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        owner
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listGuides = /* GraphQL */ `
  query ListGuides(
    $filter: ModelGuideFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGuides(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        description
        images
        rooms {
          nextToken
          startedAt
        }
        guideCatalogID
        guideCatalog {
          id
          name
          isActive
          createdAt
          updatedAt
          owner
        }
        createdAt
        updatedAt
        owner
      }
      nextToken
      startedAt
    }
  }
`;
export const getRoom = /* GraphQL */ `
  query GetRoom($id: ID!) {
    getRoom(id: $id) {
      id
      name
      description
      address
      wifiName
      wifiPass
      pmsID
      superhogEnabled
      superhogChannels
      mountLinks
      viatorLink
      viatorID
      color
      checkInSchedule
      ciboLink
      images
      propertyGuide {
        text
        description
      }
      checkIn {
        description
        image
      }
      checkOut {
        description
        image
      }
      guides {
        items {
          id
          guideId
          roomId
          createdAt
          updatedAt
          owner
        }
        nextToken
        startedAt
      }
      checkInTime
      checkOutTime
      Bookings {
        items {
          id
          notes
          status
          pmsBookingID
          reservationID
          superhogStatus
          guestID
          deviceID
          codeID
          triggerNotification
          message
          dateSchedule
          source
          code
          roomID
          createdAt
          updatedAt
          owner
        }
        nextToken
        startedAt
      }
      Device {
        id
        deviceID
        image
        name
        location
        Room {
          id
          name
          description
          address
          wifiName
          wifiPass
          pmsID
          superhogEnabled
          superhogChannels
          mountLinks
          viatorLink
          viatorID
          color
          checkInSchedule
          ciboLink
          images
          checkInTime
          checkOutTime
          createdAt
          updatedAt
          roomDeviceId
          owner
        }
        createdAt
        updatedAt
        deviceRoomId
        owner
      }
      upsells {
        items {
          id
          roomID
          upsellID
          createdAt
          updatedAt
          owner
        }
        nextToken
        startedAt
      }
      catalogs {
        items {
          id
          roomID
          categoryID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      createdAt
      updatedAt
      roomDeviceId
      owner
    }
  }
`;
export const getRoomMin = /* GraphQL */ `
  query GetRoom($id: ID!) {
    getRoom(id: $id) {
      id
      name
      description
      address
      images
      pmsID
      ciboLink
      mountLinks
      viatorLink
      checkInSchedule
      checkInTime
      checkOutTime
      createdAt
      updatedAt
      owner
    }
  }
`;

export const listRooms = /* GraphQL */ `
  query ListRooms(
    $filter: ModelRoomFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRooms(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        address
        wifiName
        wifiPass
        pmsID
        superhogEnabled
        superhogChannels
        mountLinks
        viatorLink
        viatorID
        color
        checkInSchedule
        ciboLink
        images
        checkIn {
          description
          image
        }
        checkOut {
          description
          image
        }
        guides {
          nextToken
          startedAt
        }
        checkInTime
        checkOutTime
        Bookings {
          nextToken
          startedAt
        }
        Device {
          id
          deviceID
          image
          name
          location
          createdAt
          updatedAt
          deviceRoomId
          owner
        }
        upsells {
          nextToken
          startedAt
        }
        catalogs {
          nextToken
        }
        securityItems {
          nextToken
        }
        createdAt
        updatedAt
        roomDeviceId
        owner
      }
      nextToken
      startedAt
    }
  }
`;
export const getRoomUpsell = /* GraphQL */ `
  query GetRoomUpsell($id: ID!) {
    getRoomUpsell(id: $id) {
      id
      roomID
      upsellID
      room {
        id
        name
        description
        address
        wifiName
        wifiPass
        pmsID
        superhogEnabled
        superhogChannels
        mountLinks
        viatorLink
        viatorID
        color
        checkInSchedule
        ciboLink
        images
        checkIn {
          description
          image
        }
        checkOut {
          description
          image
        }
        guides {
          nextToken
          startedAt
        }
        checkInTime
        checkOutTime
        Bookings {
          nextToken
          startedAt
        }
        Device {
          id
          deviceID
          image
          name
          location
          createdAt
          updatedAt
          deviceRoomId
          owner
        }
        upsells {
          nextToken
          startedAt
        }
        catalogs {
          nextToken
        }
        securityItems {
          nextToken
        }
        createdAt
        updatedAt
        roomDeviceId
        owner
      }
      upsell {
        id
        name
        type
        price
        images
        description
        saleType
        isActive
        prodID
        bookings {
          nextToken
          startedAt
        }
        rooms {
          nextToken
          startedAt
        }
        contactGroups {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listRoomUpsells = /* GraphQL */ `
  query ListRoomUpsells(
    $filter: ModelRoomUpsellFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRoomUpsells(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        roomID
        upsellID
        room {
          id
          name
          description
          address
          wifiName
          wifiPass
          pmsID
          superhogEnabled
          superhogChannels
          mountLinks
          viatorLink
          viatorID
          color
          checkInSchedule
          ciboLink
          images
          checkInTime
          checkOutTime
          createdAt
          updatedAt
          roomDeviceId
          owner
        }
        upsell {
          id
          name
          type
          price
          images
          description
          saleType
          isActive
          prodID
          createdAt
          updatedAt
          owner
        }
        createdAt
        updatedAt
        owner
      }
      nextToken
      startedAt
    }
  }
`;
export const getProvider = /* GraphQL */ `
  query GetProvider($id: ID!) {
    getProvider(id: $id) {
      id
      name
      website
      bio
      email
      phone
      subscribers
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listProviders = /* GraphQL */ `
  query ListProviders(
    $filter: ModelProviderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProviders(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        website
        bio
        email
        phone
        subscribers
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getGuideRoom = /* GraphQL */ `
  query GetGuideRoom($id: ID!) {
    getGuideRoom(id: $id) {
      id
      guideId
      roomId
      guide {
        id
        title
        description
        images
        rooms {
          nextToken
          startedAt
        }
        guideCatalogID
        guideCatalog {
          id
          name
          isActive
          createdAt
          updatedAt
          owner
        }
        createdAt
        updatedAt
        owner
      }
      room {
        id
        name
        description
        address
        wifiName
        wifiPass
        pmsID
        superhogEnabled
        superhogChannels
        mountLinks
        viatorLink
        viatorID
        color
        checkInSchedule
        ciboLink
        images
        checkIn {
          description
          image
        }
        checkOut {
          description
          image
        }
        guides {
          nextToken
          startedAt
        }
        checkInTime
        checkOutTime
        Bookings {
          nextToken
          startedAt
        }
        Device {
          id
          deviceID
          image
          name
          location
          createdAt
          updatedAt
          deviceRoomId
          owner
        }
        upsells {
          nextToken
          startedAt
        }
        catalogs {
          nextToken
        }
        securityItems {
          nextToken
        }
        createdAt
        updatedAt
        roomDeviceId
        owner
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listGuideRooms = /* GraphQL */ `
  query ListGuideRooms(
    $filter: ModelGuideRoomFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGuideRooms(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        guideId
        roomId
        guide {
          id
          title
          description
          images
          guideCatalogID
          createdAt
          updatedAt
          owner
        }
        room {
          id
          name
          description
          address
          wifiName
          wifiPass
          pmsID
          superhogEnabled
          superhogChannels
          mountLinks
          viatorLink
          viatorID
          color
          checkInSchedule
          ciboLink
          images
          checkInTime
          checkOutTime
          createdAt
          updatedAt
          roomDeviceId
          owner
        }
        createdAt
        updatedAt
        owner
      }
      nextToken
      startedAt
    }
  }
`;
export const serviceProductsByServiceCategoryID = /* GraphQL */ `
  query ServiceProductsByServiceCategoryID(
    $serviceCategoryID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelServiceProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    serviceProductsByServiceCategoryID(
      serviceCategoryID: $serviceCategoryID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        price
        description
        perDay
        availible
        images
        isActive
        serviceCategoryID
        serviceCategory {
          id
          name
          description
          isActive
          createdAt
          updatedAt
          owner
        }
        bookings {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      nextToken
      startedAt
    }
  }
`;
export const bookingItemsByBookingID = /* GraphQL */ `
  query BookingItemsByBookingID(
    $bookingID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelBookingItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    bookingItemsByBookingID(
      bookingID: $bookingID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        startTime
        endTime
        lengthDays
        bookingID
        productID
        booking {
          id
          notes
          checkInDate
          status
          pmsBookingID
          reservationID
          superhogStatus
          checkOutDate
          guestID
          deviceID
          codeID
          triggerNotification
          message
          dateSchedule
          source
          code
          roomID
          createdAt
          updatedAt
          owner
        }
        product {
          id
          name
          price
          description
          perDay
          availible
          images
          isActive
          serviceCategoryID
          createdAt
          updatedAt
          owner
        }
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const bookingItemsByProductID = /* GraphQL */ `
  query BookingItemsByProductID(
    $productID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelBookingItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    bookingItemsByProductID(
      productID: $productID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        startTime
        endTime
        lengthDays
        bookingID
        productID
        booking {
          id
          notes
          checkInDate
          status
          pmsBookingID
          reservationID
          superhogStatus
          checkOutDate
          guestID
          deviceID
          codeID
          triggerNotification
          message
          dateSchedule
          source
          code
          roomID
          createdAt
          updatedAt
          owner
        }
        product {
          id
          name
          price
          description
          perDay
          availible
          images
          isActive
          serviceCategoryID
          createdAt
          updatedAt
          owner
        }
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const roomCatalogsByRoomID = /* GraphQL */ `
  query RoomCatalogsByRoomID(
    $roomID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelRoomCatalogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    roomCatalogsByRoomID(
      roomID: $roomID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        roomID
        categoryID
        room {
          id
          name
          description
          address
          wifiName
          wifiPass
          pmsID
          superhogEnabled
          superhogChannels
          mountLinks
          viatorLink
          viatorID
          color
          checkInSchedule
          ciboLink
          images
          checkInTime
          checkOutTime
          createdAt
          updatedAt
          roomDeviceId
          owner
        }
        category {
          id
          name
          description
          isActive
          createdAt
          updatedAt
          owner
        }
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const roomCatalogsByCategoryID = /* GraphQL */ `
  query RoomCatalogsByCategoryID(
    $categoryID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelRoomCatalogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    roomCatalogsByCategoryID(
      categoryID: $categoryID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        roomID
        categoryID
        room {
          id
          name
          description
          address
          wifiName
          wifiPass
          pmsID
          superhogEnabled
          superhogChannels
          mountLinks
          viatorLink
          viatorID
          color
          checkInSchedule
          ciboLink
          images
          checkInTime
          checkOutTime
          createdAt
          updatedAt
          roomDeviceId
          owner
        }
        category {
          id
          name
          description
          isActive
          createdAt
          updatedAt
          owner
        }
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const roomSecurityItemsByRoomID = /* GraphQL */ `
  query RoomSecurityItemsByRoomID(
    $roomID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelRoomSecurityItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    roomSecurityItemsByRoomID(
      roomID: $roomID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        roomID
        securityItemID
        room {
          id
          name
          description
          address
          wifiName
          wifiPass
          pmsID
          superhogEnabled
          superhogChannels
          mountLinks
          viatorLink
          viatorID
          color
          checkInSchedule
          ciboLink
          images
          checkInTime
          checkOutTime
          createdAt
          updatedAt
          roomDeviceId
          owner
        }
        securityItem {
          id
          type
          isActive
          channels
          documents
          amount
          createdAt
          updatedAt
          owner
        }
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const roomSecurityItemsBySecurityItemID = /* GraphQL */ `
  query RoomSecurityItemsBySecurityItemID(
    $securityItemID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelRoomSecurityItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    roomSecurityItemsBySecurityItemID(
      securityItemID: $securityItemID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        roomID
        securityItemID
        room {
          id
          name
          description
          address
          wifiName
          wifiPass
          pmsID
          superhogEnabled
          superhogChannels
          mountLinks
          viatorLink
          viatorID
          color
          checkInSchedule
          ciboLink
          images
          checkInTime
          checkOutTime
          createdAt
          updatedAt
          roomDeviceId
          owner
        }
        securityItem {
          id
          type
          isActive
          channels
          documents
          amount
          createdAt
          updatedAt
          owner
        }
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const bookingSecurityItemsByBookingID = /* GraphQL */ `
  query BookingSecurityItemsByBookingID(
    $bookingID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelBookingSecurityItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    bookingSecurityItemsByBookingID(
      bookingID: $bookingID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        type
        signatures
        bookingID
        securityItemID
        booking {
          id
          notes
          checkInDate
          status
          pmsBookingID
          reservationID
          superhogStatus
          checkOutDate
          guestID
          deviceID
          codeID
          triggerNotification
          message
          dateSchedule
          source
          code
          roomID
          createdAt
          updatedAt
          owner
        }
        securityItem {
          id
          type
          isActive
          channels
          documents
          amount
          createdAt
          updatedAt
          owner
        }
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const bookingSecurityItemsBySecurityItemID = /* GraphQL */ `
  query BookingSecurityItemsBySecurityItemID(
    $securityItemID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelBookingSecurityItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    bookingSecurityItemsBySecurityItemID(
      securityItemID: $securityItemID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        type
        signatures
        bookingID
        securityItemID
        booking {
          id
          notes
          checkInDate
          status
          pmsBookingID
          reservationID
          superhogStatus
          checkOutDate
          guestID
          deviceID
          codeID
          triggerNotification
          message
          dateSchedule
          source
          code
          roomID
          createdAt
          updatedAt
          owner
        }
        securityItem {
          id
          type
          isActive
          channels
          documents
          amount
          createdAt
          updatedAt
          owner
        }
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const upsellContactGroupsByContactGroupID = /* GraphQL */ `
  query UpsellContactGroupsByContactGroupID(
    $contactGroupID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelUpsellContactGroupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    upsellContactGroupsByContactGroupID(
      contactGroupID: $contactGroupID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        contactGroupID
        upsellID
        contactGroup {
          id
          name
          contacts
          createdAt
          updatedAt
          owner
        }
        upsell {
          id
          name
          type
          price
          images
          description
          saleType
          isActive
          prodID
          createdAt
          updatedAt
          owner
        }
        relationshipType
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const upsellContactGroupsByUpsellID = /* GraphQL */ `
  query UpsellContactGroupsByUpsellID(
    $upsellID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelUpsellContactGroupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    upsellContactGroupsByUpsellID(
      upsellID: $upsellID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        contactGroupID
        upsellID
        contactGroup {
          id
          name
          contacts
          createdAt
          updatedAt
          owner
        }
        upsell {
          id
          name
          type
          price
          images
          description
          saleType
          isActive
          prodID
          createdAt
          updatedAt
          owner
        }
        relationshipType
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const bookingsByGuestID = /* GraphQL */ `
  query BookingsByGuestID(
    $guestID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelBookingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    bookingsByGuestID(
      guestID: $guestID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        notes
        checkInDate
        status
        pmsBookingID
        reservationID
        superhogStatus
        checkOutDate
        guestID
        deviceID
        codeID
        upsells {
          nextToken
          startedAt
        }
        products {
          nextToken
        }
        triggerNotification
        message
        dateSchedule
        source
        code
        roomID
        securityItems {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      nextToken
      startedAt
    }
  }
`;
export const bookingsByRoomID = /* GraphQL */ `
  query BookingsByRoomID(
    $roomID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelBookingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    bookingsByRoomID(
      roomID: $roomID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        notes
        checkInDate
        status
        pmsBookingID
        reservationID
        superhogStatus
        checkOutDate
        guestID
        deviceID
        codeID
        upsells {
          nextToken
          startedAt
        }
        products {
          nextToken
        }
        triggerNotification
        message
        dateSchedule
        source
        code
        roomID
        securityItems {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      nextToken
      startedAt
    }
  }
`;
export const bookingUpsellsByBookingID = /* GraphQL */ `
  query BookingUpsellsByBookingID(
    $bookingID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelBookingUpsellFilterInput
    $limit: Int
    $nextToken: String
  ) {
    bookingUpsellsByBookingID(
      bookingID: $bookingID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        payIntent
        payMethod
        bookingID
        upsellID
        booking {
          id
          notes
          checkInDate
          status
          pmsBookingID
          reservationID
          superhogStatus
          checkOutDate
          guestID
          deviceID
          codeID
          triggerNotification
          message
          dateSchedule
          source
          code
          roomID
          createdAt
          updatedAt
          owner
        }
        upsell {
          id
          name
          type
          price
          images
          description
          saleType
          isActive
          prodID
          createdAt
          updatedAt
          owner
        }
        createdAt
        updatedAt
        owner
      }
      nextToken
      startedAt
    }
  }
`;
export const bookingUpsellsByUpsellID = /* GraphQL */ `
  query BookingUpsellsByUpsellID(
    $upsellID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelBookingUpsellFilterInput
    $limit: Int
    $nextToken: String
  ) {
    bookingUpsellsByUpsellID(
      upsellID: $upsellID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        payIntent
        payMethod
        bookingID
        upsellID
        booking {
          id
          notes
          checkInDate
          status
          pmsBookingID
          reservationID
          superhogStatus
          checkOutDate
          guestID
          deviceID
          codeID
          triggerNotification
          message
          dateSchedule
          source
          code
          roomID
          createdAt
          updatedAt
          owner
        }
        upsell {
          id
          name
          type
          price
          images
          description
          saleType
          isActive
          prodID
          createdAt
          updatedAt
          owner
        }
        createdAt
        updatedAt
        owner
      }
      nextToken
      startedAt
    }
  }
`;
export const guidesByGuideCatalogID = /* GraphQL */ `
  query GuidesByGuideCatalogID(
    $guideCatalogID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelGuideFilterInput
    $limit: Int
    $nextToken: String
  ) {
    guidesByGuideCatalogID(
      guideCatalogID: $guideCatalogID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        description
        images
        rooms {
          nextToken
          startedAt
        }
        guideCatalogID
        guideCatalog {
          id
          name
          isActive
          createdAt
          updatedAt
          owner
        }
        createdAt
        updatedAt
        owner
      }
      nextToken
      startedAt
    }
  }
`;
export const roomUpsellsByRoomID = /* GraphQL */ `
  query RoomUpsellsByRoomID(
    $roomID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelRoomUpsellFilterInput
    $limit: Int
    $nextToken: String
  ) {
    roomUpsellsByRoomID(
      roomID: $roomID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        roomID
        upsellID
        room {
          id
          name
          description
          address
          wifiName
          wifiPass
          pmsID
          superhogEnabled
          superhogChannels
          mountLinks
          viatorLink
          viatorID
          color
          checkInSchedule
          ciboLink
          images
          checkInTime
          checkOutTime
          createdAt
          updatedAt
          roomDeviceId
          owner
        }
        upsell {
          id
          name
          type
          price
          images
          description
          saleType
          isActive
          prodID
          createdAt
          updatedAt
          owner
        }
        createdAt
        updatedAt
        owner
      }
      nextToken
      startedAt
    }
  }
`;
export const roomUpsellsByUpsellID = /* GraphQL */ `
  query RoomUpsellsByUpsellID(
    $upsellID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelRoomUpsellFilterInput
    $limit: Int
    $nextToken: String
  ) {
    roomUpsellsByUpsellID(
      upsellID: $upsellID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        roomID
        upsellID
        room {
          id
          name
          description
          address
          wifiName
          wifiPass
          pmsID
          superhogEnabled
          superhogChannels
          mountLinks
          viatorLink
          viatorID
          color
          checkInSchedule
          ciboLink
          images
          checkInTime
          checkOutTime
          createdAt
          updatedAt
          roomDeviceId
          owner
        }
        upsell {
          id
          name
          type
          price
          images
          description
          saleType
          isActive
          prodID
          createdAt
          updatedAt
          owner
        }
        createdAt
        updatedAt
        owner
      }
      nextToken
      startedAt
    }
  }
`;
export const guideRoomsByGuideId = /* GraphQL */ `
  query GuideRoomsByGuideId(
    $guideId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelGuideRoomFilterInput
    $limit: Int
    $nextToken: String
  ) {
    guideRoomsByGuideId(
      guideId: $guideId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        guideId
        roomId
        guide {
          id
          title
          description
          images
          guideCatalogID
          createdAt
          updatedAt
          owner
        }
        room {
          id
          name
          description
          address
          wifiName
          wifiPass
          pmsID
          superhogEnabled
          superhogChannels
          mountLinks
          viatorLink
          viatorID
          color
          checkInSchedule
          ciboLink
          images
          checkInTime
          checkOutTime
          createdAt
          updatedAt
          roomDeviceId
          owner
        }
        createdAt
        updatedAt
        owner
      }
      nextToken
      startedAt
    }
  }
`;
export const guideRoomsByRoomId = /* GraphQL */ `
  query GuideRoomsByRoomId(
    $roomId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelGuideRoomFilterInput
    $limit: Int
    $nextToken: String
  ) {
    guideRoomsByRoomId(
      roomId: $roomId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        guideId
        roomId
        guide {
          id
          title
          description
          images
          guideCatalogID
          createdAt
          updatedAt
          owner
        }
        room {
          id
          name
          description
          address
          wifiName
          wifiPass
          pmsID
          superhogEnabled
          superhogChannels
          mountLinks
          viatorLink
          viatorID
          color
          checkInSchedule
          ciboLink
          images
          checkInTime
          checkOutTime
          createdAt
          updatedAt
          roomDeviceId
          owner
        }
        createdAt
        updatedAt
        owner
      }
      nextToken
      startedAt
    }
  }
`;
export const getUsers = /* GraphQL */ `
  query GetUsers($users: String!) {
    getUsers(users: $users) {
      users
      email
      password
      name
      images
      stripeId
      pmsLinkID
      pmsLinkStatus
      pmsConnectionID
      seamIds
      notificationSources
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: TableUsersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        users
        email
        password
        name
        images
        stripeId
        pmsLinkID
        pmsLinkStatus
        pmsConnectionID
        seamIds
        notificationSources
      }
      nextToken
    }
  }
`;
